import { render, staticRenderFns } from "./CosmoClawMessageItem.vue?vue&type=template&id=6dcb5dc3&scoped=true"
import script from "./CosmoClawMessageItem.vue?vue&type=script&lang=js"
export * from "./CosmoClawMessageItem.vue?vue&type=script&lang=js"
import style0 from "./CosmoClawMessageItem.vue?vue&type=style&index=0&id=6dcb5dc3&prod&lang=scss&scoped=true"
import style1 from "./CosmoClawMessageItem.vue?vue&type=style&index=1&id=6dcb5dc3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcb5dc3",
  null
  
)

export default component.exports